import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {CustomerService} from "../../customer/customer-service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {CustomerModel} from "../../customer/customer.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";

export interface CustomerHeaderModel {
  k2Customer: string;
  k2CustomerName: string;
}

@Component({
  templateUrl: "./select-target-customer-custom-header-edit-dialog.template.pug",
  providers: [
    CustomerService,
  ],
})
export class CustomerCustomHeadersDialogComponent
  extends DialogComponent<CustomerHeaderModel, boolean>
  implements CustomerHeaderModel {
  k2Customer: string;
  k2CustomerName: string;
  customer: CustomerModel = {};
  loading: boolean = false;
  public error: Error;

  customerHeadingsForm = new FormGroup({
    customHeader1: new FormControl("", [Validators.max(70)]),
    customHeader2: new FormControl("", [Validators.max(70)]),
    customHeader3: new FormControl("", [Validators.max(70)]),
    customHeader4: new FormControl("", [Validators.max(70)]),
    customHeader5: new FormControl("", [Validators.max(70)]),
  });

  static showCreateDialog(dialogService: DialogService, input: CustomerHeaderModel): Promise<boolean> {
    return dialogService.showDialog(CustomerCustomHeadersDialogComponent, input) as Promise<boolean>;
  }

  async getCustomHeadings() {
    const {
      customHeading1,
      customHeading2,
      customHeading3,
      customHeading4,
      customHeading5,
    } = await this.customerService.getCustomerById(this.k2Customer);

    this.customerHeadingsForm.setValue({
      customHeader1: customHeading1,
      customHeader2: customHeading2,
      customHeader3: customHeading3,
      customHeader4: customHeading4,
      customHeader5: customHeading5,
    });
    this.setDisableInputs(this.customerHeadingsForm);
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async save(): Promise<void> {
    this.loading = true;
    const customer = this.customer;
    customer.id = this.k2Customer;

    const headers = this.getChanges(this.customerHeadingsForm);
    await this.customerService.updateCustomerHeaders(headers);

    this.loading = false;
    this.result = true;
    this.close();
  }

  ngOnInit(): void {
    this.getCustomHeadings();
  }

  setDisableInputs(form) {
    Object.keys(form.controls).forEach((item) => {
      if (form.controls[item].value !== "") {
        form.get(item).disable();
      }
    });
  }

  getChanges(form) {
    const changes = {customerId: this.k2Customer};

    Object.keys(form.controls).forEach((item) => {
      if (form.controls[item].dirty) {
        changes[item] = form.controls[item].value;
      }
    });
    return changes;
  }

  constructor(
    public dialogService: DialogService,
    public customerService: CustomerService,
  ) {
    super(dialogService);
  }
}
